import { render, staticRenderFns } from "./ConfidenceNotices.vue?vue&type=template&id=887eddb8&scoped=true"
import script from "./ConfidenceNotices.vue?vue&type=script&lang=js"
export * from "./ConfidenceNotices.vue?vue&type=script&lang=js"
import style0 from "./ConfidenceNotices.vue?vue&type=style&index=0&id=887eddb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887eddb8",
  null
  
)

export default component.exports